import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Button,
  CircularProgress,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { ReactNode } from 'react';

type ComponentProps = {
  title?: string;
  closeButtonLabel?: string;
  processingMessage: ReactNode;
  completeMessage?: ReactNode;
  open: boolean;
  processing: boolean;
  onClose: () => void;
};

export const StartReportJobResultDialog = ({
  title,
  closeButtonLabel,
  processingMessage,
  completeMessage,
  open,
  processing,
  onClose,
}: ComponentProps) => {

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!processing) {
          onClose();
        }
      }}
    >
      {processing ? (
        <></>
      ) : (
        <DialogTitle variant="h4">
          <Stack direction="row" alignItems="center" spacing={1}>
            <InfoIcon sx={{ color: colors.grey['700'] }} />
            <Box>{title ?? '完了'}</Box>
          </Stack>
        </DialogTitle>
      )}

      {processing ? (
        <>
          {processingMessage && (
            <DialogContent>
              <Box sx={{ pt: 3 }}>
                <DialogContentText variant="h4" sx={{ px: { xs: 'none', sm: 3 } }}>
                  {processingMessage}
                </DialogContentText>
                <Stack alignItems="center" justifyContent="center" sx={{ pt: 3 }}>
                  <CircularProgress />
                </Stack>
              </Box>
            </DialogContent>
          )}
        </>
      ) : (
        <>
          {completeMessage && (
            <DialogContent>
              <DialogContentText variant="h4" sx={{ px: { xs: 'none', sm: 3 } }}>
                <Stack
                  direction="column"
                  sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ mb: 3 }}>{completeMessage}</Box>
                </Stack>
              </DialogContentText>
            </DialogContent>
          )}
        </>
      )}
      <DialogActions>
        {processing ? (
          <></>
        ) : (
          <Button
            variant="contained"
            onClick={() => {
              onClose();
            }}
          >
            {closeButtonLabel ?? '閉じる'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
